import store from '@/store'
import { SET_CURRENT_MENU } from '@/store/types/mutations.type'
import { mainBeforeEnter } from '@/common/util/common'
import {
  PATH_NAME_CLIP,
  PATH_NAME_GLOBAL,
  PATH_NAME_HOME,
  PATH_NAME_LIVE,
  PATH_NAME_MOVIE, PATH_NAME_POPUP_CHANGE_PAYMENT,
  PATH_NAME_VOD
} from '@/common/router.const'

export default [
  {
    path: '/',
    components: {
      homeLayout: () => import('@/views/home/HomeLayout')
    },
    children: [
      {
        path: '/home',
        name: PATH_NAME_HOME,
        alias: 'home/index.html',
        props: true,
        components: {
          home: () => import(/* webpackChunkName: "Home" */'@/views/home/Home')
        },
        beforeEnter: mainBeforeEnter
      },
      // {
      //   path: '/home',
      //   name: PATH_NAME_HOME,
      //   props: true,
      //   components: {
      //     home: () => import(/* webpackChunkName: "Home" */'@/views/home/HomeNew')
      //   },
      //   beforeEnter: mainBeforeEnter
      // },
      {
        path: 'vod',
        name: PATH_NAME_VOD,
        alias: 'vod/index.html',
        components: {
          vod: () => import(/* webpackChunkName: "Vod" */'@/views/home/Vod')
        },
        redirect: () => {
          return '/index.html'
        }
      },
      {
        path: 'live',
        name: PATH_NAME_LIVE,
        alias: 'live/index.html',
        components: {
          live: () => import(/* webpackChunkName: "Live" */'@/views/home/Live')
        },
        beforeEnter: (to, from, next) => {
          store.commit(SET_CURRENT_MENU, to.name)
          next()
        }
      },
      {
        path: 'movie',
        name: PATH_NAME_MOVIE,
        alias: 'movie/index.html',
        components: {
          movie: () => import(/* webpackChunkName: "Movie" */'@/views/home/Movie')
        },
        redirect: () => {
          return '/index.html'
        }
      },
      {
        path: 'global',
        name: PATH_NAME_GLOBAL,
        alias: 'global/index.html',
        components: {
          global: () => import(/* webpackChunkName: "Movie" */'@/views/home/Global')
        },
        redirect: () => {
          return '/index.html'
        }
      },
      {
        path: 'clip',
        name: PATH_NAME_CLIP,
        alias: 'clip/index.html',
        components: {
          clip: () => import(/* webpackChunkName: "Clip" */'@/views/home/Clip')
        },
        redirect: () => {
          return '/index.html'
        }
      },
      {
        path: 'popupChangePayment',
        name: PATH_NAME_POPUP_CHANGE_PAYMENT,
        props: true,
        components: {
          popup: () => import(/* webpackChunkName: "popupChangePayment" */ '@/components/lnb/mypooq/popup/PopupChangePayment')
        }
      },
      {
        path: 'category/main',
        name: 'MainCategory',
        components: {
          category: () =>
            import(/* webpackChunkName: "MainCategory" */ '@/views/category/Main'),
        },
        // beforeEnter: mainBeforeEnter
      },
      {
        path: '/category/sub',
        name: 'SubCategory',
        components: {
          category: () =>
            import(/* webpackChunkName: "SubCategory" */ '@/views/category/Sub'),
        },
        props: true,
        // beforeEnter: mainBeforeEnter
      },
      // {
      //   path: 'category',
      //   name: PATH_NAME_CATEGORY,
      //   alias: 'category/index.html',
      //   components: {
      //     category: () => import(/* webpackChunkName: "Category" */'@/views/home/Category')
      //   },
      //   beforeEnter: mainBeforeEnter
      // }
    ]
  }
]
